import React from 'react';

export const useForceUpdate = (): CallableFunction => {
  const [, setValue] = React.useState(0);
  return React.useCallback(() => setValue((v) => v + 1), []);
};
